<template>
<div class="bg-index" :style="{backgroundImage: 'url(' + bg + ')'}">
    <div class="buying-main">
        <div class="zhanwei"></div>
        <div class="buying-main-type mianbaoxie">
            <el-image class="detail-image" :src="require('@/assets/image/home-order.png')"></el-image>
            <div>我的订单•{{fomr.status == 1?'待发货':'已发货'}}详情</div>
        </div>
        <div class="buying-main-title">
            <div>在线寄件</div>
            <div class="buying-main-type">
                <div class="buying-pubilc buying-pubilc-avatar">{{fomr.wl_type == 1 ?'海运':'空运'}}</div>
            </div>
        </div>

        <div class="buying-all-public">
            <div class="buying-title">
                <el-image class="buying-main-image" :src="require('@/assets/image/ji.png')"></el-image>
                <div>寄件人</div>
            </div>
            <div class="buying-form">
                <el-row :gutter="80">
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>姓名：<input v-model="fomr.jj_name" readonly /></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>手机号码：<input v-model="fomr.jj_phone" readonly /></div>
                        </div>
                    </el-col>
                </el-row>
                <div class="input-all">
                    <div class="input-xing">*</div>
                    <div class="detail-intpus">地址： <input class="detail-intpu" v-model="fomr.jj_dz" readonly /></div>
                </div>
            </div>
        </div>


        <div class="buying-all-public">
            <div class="buying-title ">
                <el-image class="buying-main-image" :src="require('@/assets/image/zhong.png')"></el-image>
                <div>国内中转仓库地址</div>
            </div>
            <div class="buying-form">
                <el-row :gutter="80">
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>姓名：<input v-model="fomr.zz_name" readonly /></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>手机号码：<input v-model="fomr.zz_phone" readonly /></div>
                        </div>
                    </el-col>
                </el-row>
                <div class="input-all">
                    <div class="input-xing">*</div>
                    <div class="detail-intpus">地址：<input class="detail-intpu" v-model="fomr.zz_dz" readonly /></div>
                </div>
            </div>
            
            <div class="buying-titles">
                <div class="buying-title">
                    <el-image class="buying-main-image" :src="require('@/assets/image/shou2.png')"></el-image>
                    <div>国内中转仓库地址</div>
                </div>
            </div>
            <div class="buying-form">
                <el-row :gutter="80">
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>姓名：<input v-model="fomr.sj_name" readonly /></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>手机号码：<input v-model="fomr.sj_phone" readonly /></div>
                        </div>
                    </el-col>
                </el-row>
                <div class="input-all">
                    <div class="input-xing">*</div>
                    <div class="detail-intpus">地址：<input class="detail-intpu" v-model="fomr.sj_dz" readonly /></div>
                </div>
            </div>
        </div>


        <div class="buying-all-public" v-for="(item,index) in fomr.goods" >
            <div class="buying-title">
                <div>物品信息</div>
            </div>
            <div class="buying-form">
                <el-row :gutter="80">
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>物品品名：</div>
                            <input :value="item.goods_name" readonly/>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="input-all">
                            <div class="input-xing">*</div>
                            <div>快递单号：</div>
                            <input  :value="item.kd_order" width="220px" readonly/>
                            <el-button @click="queryClick(item.kd_order)">查询物流</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
				<div class="buying-form">
				    <el-row :gutter="80">
				        <el-col :span="12">
				            <div class="input-all">
				                <div class="input-xing">*</div>
				                <div>数量：</div>
				                <input  :value="item.number" readonly/>
				            </div>
				        </el-col>
				        <el-col :span="12">
				            <div class="input-all">
				                <div class="input-xing">*</div>
				                <div>货值：</div>
				                <input  :value="item.goods_value" width="220px" readonly/>
				            </div>
				        </el-col>
				    </el-row>
				</div>
				<div class="buying-form">
				    <el-row :gutter="80">
				        <el-col :span="12">
				            <div class="input-all">
				                <div class="input-xing">*</div>
				                <div>内容：</div>
				                <input  :value="item.material" readonly/>
				            </div>
				        </el-col>
				    </el-row>
				</div>
        </div>

        
    </div>
</div>
</template>

<script>
import {order,getset} from '@/api/index'
export default {
    name:'Detail',
    data(){
        return{
            fomr:{
                // jj 寄件人
                jj_name:'',// 姓名
                jj_phone:'',// 手机
                jj_dz:'',// 地址
                // 中转
                zz_phone:'',
                zz_name:'',
                zz_dz:'',
                // 收件人
                sj_name:'',
                sj_phone:'',
                sj_dz:'',
                wl_type:1, //物流方式:1海运,2空运
                wp_type:'',// 物品类型
                yg_zl:'', //预估重量,非必填
                kd_order:'', //快递单号
            },
            bg:'',
        }
    },
    created(){
        let id = this.$route.query.id
        let status = this.$route.query.status
        getset({name:'detail_bg'}).then(res=>{this.bg = this.$store.state.baseUrl + res.data})
        this.getOrderDetail(id,status)
    },
    methods:{
        getOrderDetail(id,status){
            order({id,status}).then(res=>{
                this.fomr = res.data
					 console.log(this.fomr,'******************')
            })
        },
        queryClick(conter){

                //创建一个input框
                const input = document.createElement("input");
                //将指定的DOM节点添加到body的末尾
                document.body.appendChild(input);
                //设置input框的value值为直播地址
                input.setAttribute("value", conter);
                //选取文本域中的内容
                input.select();
                //copy的意思是拷贝当前选中内容到剪贴板
                //document.execCommand（）方法操纵可编辑内容区域的元素
                //返回值为一个Boolean，如果是 false 则表示操作不被支持或未被启用
                if (document.execCommand("copy")) {
                    document.execCommand("copy");
                }
                //删除这个节点
                document.body.removeChild(input);

                this.$message({
                    type:'success',
                    message:'复制成功'
                })

                setTimeout(()=>{
                    window.open(this.fomr.ship_url)
                },1500)


            // if(this.fomr.status == 2){
            //     document.execCommand(this.fomr.kd_order)
            //     this.$message({
            //         type:'success',
            //         message:'复制成功'
            //     })
            //     setTimeout(()=>{
            //         let url = 'http://51yorky.com/search?trackNos'
            //         window.open(url)
            //     },2000)
            // }else{
                // let url = 'http://stoexpresscanada.com/admin/code/index?express=' + this.fomr.kd_order
                // window.open(url)
            // }
            
        },
    },
}
</script>

<style>

/* .el-scrollbar{height:100%;} */
.el-scrollbar__wrap {
    overflow-x:hidden;
    overflow: hidden;
}
</style>

<style scoped>
::-webkit-input-placeholder { color:#BBBBBB; }
::-moz-placeholder { color:#BBBBBB; } /* firefox 19+ */
:-ms-input-placeholder { color:#BBBBBB; } /* ie */
input:-moz-placeholder { color:#BBBBBB; }
input:focus{
	outline: medium;
}

.zhanwei{
    height: 120px;
    background: transparent;
}
.buying-main{
    width: 70%;
    margin: auto;
    padding-top: 38px;
}
.buying-main-title{
    height: 112px;
    background: #F6AF16;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    font-size: 28px;
}
.buying-main-type{
    display: flex;
    align-items: center;
}
.buying-pubilc{
    width: 145px;
    height: 47px;
    line-height: 47px;
    text-align: center;
}
.buying-pubilc-avatar{
    background: #FFFFFF;
    border-radius: 24px;
    font-size: 28px;
    font-weight: bold;
    color: #C22900;
}
.buying-main-image{
    width: 54px;
    height: 54px;
    margin-right: 30px;
}
.buying-all-public{
    background: #ffffff;
    margin-top: 20px;
    padding: 48px 30px;
    font-size: 28px;
    color: #333333;
    border-radius: 4px;
}
.buying-title{
    display: flex;
    align-items: center;
}
.input-xing{
    color: #C43410;
    width: 20px;
}
.input-all{
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #BBBBBB;
    padding: 40px 0 26px 0;
    border-bottom: 2px solid #F5F5F5;;
}
input{
    border: none;   
    font-size: 28px;
}
.buying-form{
    margin: 0 50px;
}
.buying-titles{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 52px;
}
.buying-select{
    width: 239px;
    height: 57px;
    background: #506EDA;
    border-radius: 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFFFFF;
}
.buying-select-image{
    width: 34px;
    height: 34px;
    margin-right: 20px;
}
.input-danhao{
    color: #BBBBBB;
}
.select-all{
    margin-top: 30px;
    display: flex;
    align-items: center;
    flex-wrap: wrap 
}
.select-all div{
    height: 50px;
    line-height: 50px;
    background: #F5F5F5;
    border-radius: 3px;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    padding: 0 40px;
}
.bottom-form{
    margin-top: 45px;
}
.sumbit-button{
    width: 100%;
    height: 126px;
    background: #F6AF16;
    border-radius: 10px;
    font-size: 32px;
    font-weight: bold;
    color: #FFFFFF;
    border: none;
    margin: 48px 0 62px 0;
}
.dialog-all{
    display: flex;
    align-items: center;
    padding: 0 27px;
    width: 706px;
    height: 185px;
    background: #F5F5F5;
    border-radius: 10px;
    margin-bottom:20px;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
}
.dialog-main{
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
}
.dialog-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:23px;
}
.dialog-button{
    width: 66px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #FF521E;
    border-radius: 8px;
    font-size: 18px;
    color: #FF521E;
}
.dialog-name{
    font-size: 29px;
    font-weight: 500;
    color: #333333;
    margin-right:23px;
}
.dialog-phone{    
    font-size: 25px;
    font-weight: 500;
    color: #333333;
}
.detail-image{
    width: 30px;
    height: 30px;
    margin-right: 20px;
}
.mianbaoxie{
    color: #23367C;
    height: 80px;
    line-height: 80px;
    font-weight: bold;
}
.detail-intpus{
    width: 90%;
}
.detail-intpu{
    width: 85%;
}
.bg-index{
    background-attachment:fixed;
    background-repeat: no-repeat;
    background-size: cover; 
    background-position: center center;
}
</style>